module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    ref: "focusme",
    staticStyle: {
      "width": "0",
      "height": "0"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['f6']),
      expression: "['f6']"
    }],
    on: {
      "shortkey": _vm.selecionarLote
    }
  }), _vm._v(" "), _c('change-status', {
    ref: "changeStatus"
  }), _vm._v(" "), _c('div', {
    staticClass: "keyboard",
    class: {
      khide: !_vm.show
    }
  }, [_c('a', {
    staticClass: "toggle",
    on: {
      "click": _vm.toggleKeyboard
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "control-anterior",
    on: {
      "shortkey": _vm.anterior,
      "click": _vm.anterior
    }
  }, [_vm._v("Anterior "), _c('i', [_vm._v("←")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "control-proximo",
    on: {
      "shortkey": _vm.proximo,
      "click": _vm.proximo
    }
  }, [_vm._v("Próximo "), _c('i', [_vm._v("\n        →")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['delete']),
      expression: "['delete']"
    }],
    staticClass: "control-deletar-lance",
    on: {
      "shortkey": _vm.deletarLance,
      "click": _vm.deletarLance
    }
  }, [_vm._v("Deletar Lance "), _c('i', [_vm._v("Delete")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['1']),
      expression: "['1']"
    }],
    staticClass: "control-aberto",
    on: {
      "shortkey": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_ABERTO_PARA_LANCES)
      },
      "click": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_ABERTO_PARA_LANCES)
      }
    }
  }, [_vm._v("Aberto "), _c('i', [_vm._v("1")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['2']),
      expression: "['2']"
    }],
    staticClass: "control-pregao",
    on: {
      "shortkey": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_EM_PREGAO)
      },
      "click": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_EM_PREGAO)
      }
    }
  }, [_vm._v("Em Pregão "), _c('i', [_vm._v("2")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['+']),
      expression: "['+']"
    }],
    staticClass: "control-incremento",
    on: {
      "shortkey": function($event) {
        return _vm.lanceManual(0)
      },
      "click": function($event) {
        return _vm.lanceManual(0)
      }
    }
  }, [_vm._v("Incremento "), _c('i', [_vm._v("+")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['3']),
      expression: "['3']"
    }],
    staticClass: "control-dolheuma",
    on: {
      "shortkey": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_DOULHE_UMA)
      },
      "click": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_DOULHE_UMA)
      }
    }
  }, [_vm._v("Dou-lhe Uma "), _c('i', [_vm._v("3")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['4']),
      expression: "['4']"
    }],
    staticClass: "control-doulheduas",
    on: {
      "shortkey": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_DOULHE_DUAS)
      },
      "click": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_DOULHE_DUAS)
      }
    }
  }, [_vm._v("Dou-lhe Duas "), _c('i', [_vm._v("4")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['0']),
      expression: "['0']"
    }],
    staticClass: "control-baixaoferta",
    on: {
      "shortkey": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_BAIXA_OFERTA)
      },
      "click": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_BAIXA_OFERTA)
      }
    }
  }, [_vm._v("Rejeitado "), _c('i', [_vm._v("0")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ([',']),
      expression: "[',']"
    }],
    staticClass: "control-semlicitantes",
    on: {
      "shortkey": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_SEM_LICITANTES)
      },
      "click": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_SEM_LICITANTES)
      }
    }
  }, [_vm._v("Sem Licitantes "), _c('i', [_vm._v(",")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['*']),
      expression: "['*']"
    }],
    staticClass: "control-homologando",
    on: {
      "shortkey": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_HOMOLOGANDO)
      },
      "click": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_HOMOLOGANDO)
      }
    }
  }, [_vm._v("Homologando "), _c('i', [_vm._v("*")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['9']),
      expression: "['9']"
    }],
    staticClass: "control-condicional",
    on: {
      "shortkey": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_CONDICIONAL)
      },
      "click": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_CONDICIONAL)
      }
    }
  }, [_vm._v("Condicional "), _c('i', [_vm._v("9")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['.']),
      expression: "['.']"
    }],
    staticClass: "control-vendido",
    on: {
      "shortkey": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_VENDIDO)
      },
      "click": function($event) {
        return _vm.loteStatus(_vm.Status.STATUS_VENDIDO)
      }
    }
  }, [_vm._v("Vendido "), _c('i', [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['t']),
      expression: "['t']"
    }],
    staticClass: "text-center no-select",
    on: {
      "shortkey": function($event) {
        return _vm.renovarTempo()
      }
    }
  }, [_vm._v("Aperte "), _c('strong', {
    staticClass: "label label-default box-shadow m-r-xs m-l-xs"
  }, [_vm._v("T")]), _vm._v(" para renovar o tempo\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0f4de22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao/components/Keyboard.vue
// module id = 868
// module chunks = 2